import React, { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import './LoginScreen.css';

export default function LoginScreen({ logo, institutionName = 'OnTest', kicker, background, heroTitle, heroDescription, credential, password, onCredentialChange, onPasswordChange, onSubmit, error, submitting, credentialType = 'email' }) {
    const [showPassword, setShowPassword] = useState(false);
    return <div className="ontest-access">
        <section className="access-panel" aria-label={kicker}>
            <div className="access-body">
                <div className="access-logo"><img src={logo} alt={institutionName} /></div>
                <div className="access-intro">
                    <span className="access-kicker">{kicker}</span>
                    <h1 className="access-title">Bem-vindo</h1>
                    <p className="access-subtitle">Acesse sua conta para continuar.</p>
                </div>
                <form className="access-form" onSubmit={onSubmit}>
                    <div className="access-field">
                        <label htmlFor="access-credential">E-mail <span aria-hidden="true">*</span></label>
                        <input id="access-credential" name="credencial" type={credentialType} value={credential} onChange={onCredentialChange} placeholder="E-mail" autoComplete="username" required />
                    </div>
                    <div className="access-field">
                        <label htmlFor="access-password">Senha <span aria-hidden="true">*</span></label>
                        <div className="access-password">
                            <input id="access-password" name="password" type={showPassword ? 'text' : 'password'} value={password} onChange={onPasswordChange} placeholder="Digite sua senha" autoComplete="current-password" required />
                            <button className="access-password-toggle" type="button" aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'} aria-pressed={showPassword} onClick={() => setShowPassword(value => !value)}>
                                {showPassword ? <AiFillEyeInvisible aria-hidden="true" /> : <AiFillEye aria-hidden="true" />}
                            </button>
                        </div>
                    </div>
                    {error && <div className="access-error" role="alert">{error}</div>}
                    <button className="access-submit" type="submit" disabled={submitting}>
                        {submitting && <span className="access-spinner" aria-hidden="true" />}
                        {submitting ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>
                <footer className="access-footer">© {new Date().getFullYear()} OnTest</footer>
            </div>
        </section>
        <aside className="access-hero" style={{ backgroundImage: `url(${background})` }}>
            <div className="access-hero-copy"><span>OnTest</span><h2>{heroTitle}</h2><p>{heroDescription}</p></div>
        </aside>
    </div>;
}

export function LoginScreenLoading() {
    return <div className="ontest-access-loading" role="status"><span className="access-spinner" aria-hidden="true" /><span>Carregando...</span></div>;
}
